<template>
  <div style="width: 100%">
    <sui-form v-if="school">
      <sui-form-field class="required" v-bind:class="fieldClass('rollNumber')">
        <label>Roll number</label>
        <input placeholder="Roll number" v-validate="'required'" name="rollNumber" type="text"
          v-model="school.rollNumber" :readonly="!!school.id" />
      </sui-form-field>
      <sui-form-field class="required" v-bind:class="fieldClass('name')">
        <label>Name</label>
        <input placeholder="Name" v-validate="'required'" name="name" type="text" v-model="school.name" />
      </sui-form-field>
      <sui-form-field>
        <label>Email address</label>
        <input placeholder="Email address" name="emailAddress" type="email" v-model="school.emailAddress" />
      </sui-form-field>
      <sui-form-field class="required" v-bind:class="fieldClass('totalStudentCount')">
        <label>Student count</label>
        <input placeholder="100" v-validate="'required'" name="totalStudentCount" type="number" min="1"
          v-model="school.totalStudentCount" />
      </sui-form-field>
      <sui-form-field>
        <label>Address line 1</label>
        <input placeholder="Address line 1" name="address1" type="text" v-model="school.address1" />
      </sui-form-field>
      <sui-form-field>
        <label>Address line 2</label>
        <input placeholder="Address line 2" name="address2" type="text" v-model="school.address2" />
      </sui-form-field>
      <sui-form-field>
        <label>Address line 3</label>
        <input placeholder="Address line 3" name="address3" type="text" v-model="school.address3" />
      </sui-form-field>
      <sui-form-field>
        <label>Address line 4</label>
        <input placeholder="Address line 4" name="address4" type="text" v-model="school.address4" />
      </sui-form-field>
      <sui-form-field>
        <label>County</label>
        <input placeholder="County" name="county" type="text" v-model="school.county" />
      </sui-form-field>
      <sui-form-field>
        <label>Local authority</label>
        <input placeholder="Local authority" name="localAuthority" type="text" v-model="school.localAuthority" />
      </sui-form-field>
      <sui-form-field>
        <label>Eircode</label>
        <input placeholder="Eircode" name="eircode" type="text" v-model="school.eircode" />
      </sui-form-field>
      <sui-form-field class="required" v-bind:class="fieldClass('availableLanguages')">
        <label>Available languages</label>
        <ul style="list-style-type: none; padding: 0">
          <li>
            <input v-validate="'required'" name="availableLanguages" id="ga" type="checkbox" value="ga"
              v-model="school.availableLanguages" />
            <label for="ga">Irish</label>
          </li>
          <li>
            <input v-validate="'required'" name="availableLanguages" id="en" type="checkbox" value="en"
              v-model="school.availableLanguages" />
            <label for="en">English</label>
          </li>
        </ul>
      </sui-form-field>
      <sui-form-field class="required" v-bind:class="fieldClass('defaultLanguage')">
        <label>Default language</label>
        <sui-dropdown placeholder="Default language" selection v-validate="'required'" name="defaultLanguage"
          :options="languages" v-model="school.defaultLanguage" />
        <span>{{ errors.first('defaultLanguage') }}</span>
      </sui-form-field>

      <sui-button type="button" positive icon="plus" v-on:click="submit">
        Save
      </sui-button>
    </sui-form>
  </div>
</template>

<script>
export default {
  name: 'SchoolForm',
  props: ['school', 'error'],
  data() {
    return {
      languages: [
        { text: 'English', value: 'en' },
        { text: 'Irish', value: 'ga' },
      ],
    };
  },
  methods: {
    reset() {
      this.$validator.reset();
    },
    fieldClass(name) {
      const result = [];
      if (this.errors.first(name)) {
        result.push('error');
      }
      return result;
    },
    submit() {
      this.$validator.validate().then((result) => {
        if (result) {
          this.$emit('saved');
        }
      });
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/components/schools/SchoolForm.vue